import { getContext } from 'svelte';
export const ACTIONS_CONTEXT = 'actions';
export function useActions() {
    return getContext(ACTIONS_CONTEXT);
}
function sendMessage(action, data = '') {
    if (window.parent === window) {
        return null;
    }
    window.parent.postMessage({ action: `JEWELLERY_BUILDER_${action}`, data }, '*');
}
['pushState', 'replaceState'].forEach((changeState) => {
    window.history[changeState] = new Proxy(History.prototype[changeState], {
        apply(target, thisArg, argList) {
            const [, , url] = argList;
            sendMessage('UPDATE_URL', url);
            return target.apply(thisArg, argList);
        }
    });
});
export function createActions() {
    return {
        redirectToCart(cartURL) {
            // TODO: Rename this in the parent frame:
            if (sendMessage('ADD_TO_CART', cartURL) === null) {
                location.href = cartURL;
            }
        },
        orderDrawings(drawingsUrl) {
            if (sendMessage('ORDER_DRAWINGS', drawingsUrl) === null) {
                location.href = drawingsUrl;
            }
        },
        orderASample(sampleUrl) {
            if (sendMessage('ORDER_SAMPLE', sampleUrl) === null) {
                location.href = sampleUrl;
            }
        },
        requestHelp(customisationUrl) {
            if (sendMessage('REQUEST_HELP', customisationUrl) === null) {
                location.href = customisationUrl;
            }
        },
        copyLink(copyLink) {
            sendMessage('COPY_LINK', copyLink);
        },
        ready() {
            sendMessage('READY');
        }
    };
}
